import { OpeningPlacementType } from 'utils/opening-position-types';

const placements = new Map<string, OpeningPlacementType>();
let lastPointer: { x: number; y: number } | null = null;

export function setOpeningDragPointer(clientX: number, clientY: number) {
  lastPointer = { x: clientX, y: clientY };
}

export function getOpeningDragPointer(): { x: number; y: number } | null {
  return lastPointer;
}

export function setLiveOpeningDragPlacement(
  spaceId: string,
  placement: OpeningPlacementType | null
) {
  if (!placement) {
    placements.delete(spaceId);
    return;
  }

  placements.set(spaceId, placement);
}

export function getLiveOpeningDragPlacement(
  spaceId: string
): OpeningPlacementType | undefined {
  return placements.get(spaceId);
}

export function clearLiveOpeningDragPlacements() {
  placements.clear();
  lastPointer = null;
}
